module.exports = __webpack_public_path__ + "img/20210206_180509.ccf70a11.jpg";